export const isQrCodeTokenValid = (nbf: number, exp: number): boolean => {
  const curMillis = new Date().valueOf();
  return curMillis > nbf && curMillis < exp;
};
